import { SMALL, EXTRA_SMALL, MEDIUM } from '../../constants/sizes';
export const LOADING_SPINNER_SIZES = {
  [EXTRA_SMALL]: 24,
  [SMALL]: 32,
  [MEDIUM]: 48
};